<template>
        <a :href="link" class="scroll-link"
           :class="'scroll-link--' + arrow + styleTypeClass">
            <slot></slot>
            <svg v-if="styleType && styleType!='empty'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 23">
                <g fill="none" fill-rule="evenodd">
                    <path :stroke="arrowColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1.2 3.8l18.3 18.1L37.4 3.8" opacity=".8"/>
                    <path :fill="arrowColor" d="M5.4 0l14 14.2L33.9 0z"/>
                </g>
            </svg>
            <svg v-else-if="styleType=='empty'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 18">
                <g fill="none" fill-rule="evenodd" :stroke="arrowColor" stroke-linecap="round" stroke-linejoin="round" opacity=".8">
                    <path stroke-width="1.5" d="m1 3 13.2 14L27 3"/>
                    <path stroke-width="1.2" d="m6 1 8.1 8.5L22 1"/>
                </g>
            </svg>

        </a>
</template>

<script>
import AOS from 'aos';
export default {
    props: {
        link: {
            type: String,
            required: true
        },
        styleType: {
            type: String,
        },
        arrow: {
            type: String,
        }
    },
    computed:{
        styleTypeClass(){
            return this.styleType ? '--'+this.styleType : '--empty';
        },
        arrowColor(){
            if(this.styleType == 'inverted') {
                return 'rgba(255,255,255,.9)'
            } else if(this.arrow == 'orange'){
                return '#FF8600'
            } else if(this.arrow == 'blue'){
                return '#0AA7C8'
            } else {
                return '#FFFFFF'
            }
        }
    },
    mounted() {
        AOS.init();
    }
}
</script>

<style lang="scss" scoped>
.scroll-link {
    position: absolute;
    bottom: 36px;
    left: 50%;
    transform: translateX(-50%);

    padding: 10px 23px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    color: #0AA7C8;
    text-transform: uppercase;
    text-align: center;

    min-width: 219px;

    //background-color: #fff;

    &--orange--empty {
        color: #FF8600;
        background-color: transparent;
    }
    &--blue--empty {
        color: #0AA7C8;
        background-color: transparent;
    }
    &--white--empty {
        color: #fff;
        background-color: transparent;
    }

    &--orange--squared {
        color: #fff;
        background-color: #FF8600;
    }
    &--blue--squared {
        color: #fff;
        background-color: #0AA7C8;
    }

    &--orange--inverted {
        color: #FF8600;
        background-color: rgba(255,255,255,.9);
    }
    &--blue--inverted {
        color: #0AA7C8;
        background-color: rgba(255,255,255,.9);
    }
     svg{
         width: 36px;
         position: absolute;
         top:100%;
         left: 50%;
         transform: translateX(-50%);
     }
}
</style>
